/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const _pagepath = '/search/';

	// <商品検索>
	const searchBlock = () => {
		const $container = document.querySelector('.container');
		const searchForm = document.querySelector('.js-search-form');
		const searchOpenBtn = document.querySelector('.js-search-open');
		const searchCloseBtn = document.querySelector('.js-search-close');

		// 「条件から探す」開閉
		let scrollTopNow;
		const fixedOnContainer = () => {
			scrollTopNow = window.scrollY;
			$container.style.position = 'fixed';
			$container.style.width = '100%';
			$container.style.top = -1 * scrollTopNow;
			$container.style.left = 0;
		};
		const fixedOffContainer = () => {
			$container.style.position = 'static';
			window.scrollTo({ top: scrollTopNow });
		};

		if (searchOpenBtn) {
			searchOpenBtn.addEventListener('click', () => {
				searchForm.classList.add(a);
				fixedOnContainer();
			});
			searchCloseBtn.addEventListener('click', () => {
				searchForm.classList.remove(a);
				fixedOffContainer();
			});
		}

		// 検索条件リセット
		// const searchClearBtn = document.querySelector('.js-search-clear');
		// if (searchClearBtn) {
		// 	searchClearBtn.addEventListener('click', () => {
		// 		const inputs = searchForm.querySelectorAll('input[type="checkbox"], input[type="radio"]');
		// 		inputs.forEach((input) => {
		// 			input.checked = false;
		// 		});
		// 		const inputsText = searchForm.querySelectorAll('input[type="text"]');
		// 		inputsText.forEach((input) => {
		// 			input.value = '';
		// 		});
		// 	});
		// }
	}

	// <商品詳細> メインスライダー
	const detailMainSlider = () => {
		const mainSlider = document.querySelector('.js-main-slider');
		const thumbSlider = document.querySelector('.js-thumb-slider');
		if (!mainSlider || !thumbSlider) return;

		const thumbSwiper = new Swiper(thumbSlider, {
			spaceBetween: 8,
			slidesPerView: 4,
			freeMode: true,
			watchSlidesProgress: true,
			breakpoints: {
				1024: {
					spaceBetween: 0,
					slidesPerView: 6,
				},
			},
		});

		const mainSwiper = new Swiper(mainSlider, {
			effect: 'fade',
			loop: false,
			slidesPerView: 1,
			speed: 500,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
			},
			thumbs: {
				swiper: thumbSwiper,
			},
			keyboard: {
				enabled: true,
			},
		});
	};

	const recommendSlider = () => {
		const recommendSlider = document.querySelector('.js-recommend-slider');
		if (!recommendSlider) return;
		const swiper = new Swiper(recommendSlider, {
			loop: true,
			slidesPerView: 2,
			slidesPerGroup: 2,
			// initialSlide: 1,
			spaceBetween: 4,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				1024: {
					slidesPerView: 4,
					spaceBetween: 24,
					slidesPerGroup: 4,
				},
			},
		});
	};

	// 税抜価格表示処理
	// const displayTaxExcludedPrice = () => {
	// 	const priceElements = document.querySelectorAll('.rt_cf_p_price_is');

	// 	priceElements.forEach((element) => {
	// 		const rtCfPriceSpan = element.querySelector('.rt_cf_p_price');
	// 		const smallSpan = element.querySelector('.__small span');

	// 		if (rtCfPriceSpan && smallSpan) {
	// 			// rt_cf_p_priceの値を取得（数字部分のみ）
	// 			const priceText = rtCfPriceSpan.textContent;
	// 			const priceMatch = priceText.match(/¥?([\d,]+)/);

	// 			if (priceMatch) {
	// 				// カンマを除去して数値に変換
	// 				const priceIncludingTax = parseInt(priceMatch[1].replace(/,/g, ''));

	// 				// 税抜価格を計算（1.1で割る）
	// 				const taxExcludedPrice = Math.floor(priceIncludingTax / 1.1);

	// 				// 3桁区切りのフォーマットで表示
	// 				const formattedPrice = taxExcludedPrice.toLocaleString();

	// 				// 税抜価格を表示
	// 				smallSpan.textContent = `¥${formattedPrice}`;
	// 			}
	// 		}
	// 	});
	// };

	// Function Movie表示制御
	const functionMovieControl = () => {
		const movieSection = document.querySelector('.products-detail-movie');
		if (!movieSection) return;

		// 動画が存在するかチェック
		const movieItems = movieSection.querySelectorAll('.products-detail-movie-item .mod-video');
		let hasVideo = false;

		movieItems.forEach((item) => {
			const iframe = item.querySelector('iframe[src*="youtube.com/embed"]');
			const thumbnailSpan = item.querySelector('span[class*="rt_cf_p_video_thum_img"]');

			if (iframe && iframe.src && iframe.src.includes('youtube.com/embed/')) {
				// YouTubeのsrc URLから動画IDを抽出
				const videoId = iframe.src.split('/embed/')[1].split('?')[0];

				// 動画IDが存在し、有効な場合
				if (videoId && videoId !== '' && videoId !== 'undefined') {
					hasVideo = true;

					// サムネイル画像の処理
					if (thumbnailSpan) {
						const thumbnailContent = thumbnailSpan.textContent.trim();

						// サムネイル画像が存在する場合（$動画サムネイル画像X$以外のコンテンツがある）
						if (thumbnailContent && !thumbnailContent.match(/^\$動画サムネイル画像\d+\$$/)) {
							// カスタムサムネイルを使用
							thumbnailSpan.classList.remove('di_none');
							iframe.style.display = 'none';

							// サムネイルクリック時にiframeを表示
							thumbnailSpan.addEventListener('click', () => {
								thumbnailSpan.style.display = 'none';
								iframe.style.display = 'block';
								// 自動再生のためsrcにautoplay=1を追加
								if (!iframe.src.includes('autoplay=1')) {
									iframe.src += (iframe.src.includes('?') ? '&' : '?') + 'autoplay=1';
								}
							});
						} else {
							// デフォルトのYouTubeサムネイルを使用
							thumbnailSpan.style.display = 'none';
							iframe.style.display = 'block';
						}
					}
				}
			}
		});

		// 動画がない場合はFunction Movieエリア全体を非表示
		if (!hasVideo) {
			movieSection.style.display = 'none';
		}
	};

	// 検索パラメータの有無をチェック
	const hasSearchParams = () => {
		const urlParams = new URLSearchParams(window.location.search);
		console.log('Current URL params:', urlParams.toString());
		
		const searchParamKeys = [
			'p_keyword_1', 'p_keyword_2', 'p_keyword_3', 'p_keyword_4', 'p_keyword_5',
			'p_brand', 'p_collection', 'p_models', 'p_price', 'p_dial', 'p_dial_material',
			'p_case_color', 'p_case_material', 'p_case_size', 'p_strap', 'p_movement',
			'p_water_resistant', 'p_movement_type', 'p_power_reserve'
		];

		const result = searchParamKeys.some(key => {
			const value = urlParams.get(key);
			return value;
		});
		
		console.log('hasSearchParams result:', result);
		return result;
	};

	// 検索結果表示の切り替え（recommendとall）
	const toggleSearchDisplay = () => {
		const recommendSection = document.querySelector('.js-search-recommend');
		const allSection = document.querySelector('.js-search-all');

		if (!recommendSection || !allSection) return;

		if (hasSearchParams()) {
			// 検索パラメータがある場合
			recommendSection.style.display = 'none';
			allSection.style.display = 'block';
		} else {
			// 検索パラメータがない場合
			recommendSection.style.display = 'block';
			allSection.style.display = 'none';
		}
	};

	// 商品リスト表示切り替え処理
	const searchResultSortControl = () => {
		// 並び替え種別と対応するバインドクラス名
		const SORT_CONFIG = {
			default: 'rt_bn_products_list',
			expensive: 'rt_bn_products_list_expensive',
			chip: 'rt_bn_products_list_chip',
			release: 'rt_bn_products_list_release'
		};
		const SORT_TYPES = Object.keys(SORT_CONFIG);

		const urlParams = new URLSearchParams(window.location.search);

		// 現在表示されているセクション（recommendまたはall）を取得
		const isSearchResults = hasSearchParams();
		const activeSection = isSearchResults ?
			document.querySelector('.js-search-all') :
			document.querySelector('.js-search-recommend');

		if (!activeSection) return;

		// アクティブなセクション内のセレクトボックスを取得
		const sortSelect = activeSection.querySelector('#select_01') || activeSection.querySelector('select');
		if (!sortSelect) return;

		// クラス名サフィックスを決定（recommendの場合は_def付き）
		const suffix = isSearchResults ? '' : '_def';
		const getBindName = (type) => `${SORT_CONFIG[type]}${suffix}`;

		// URLパラメータから初期の並び順を決定
		// ページャーのリンクには4種類すべての_skipが出力され、
		// 選択中の並び順以外は値が空になるため、値の有無で判定する
		const getCurrentSortType = () => {
			for (const type of SORT_TYPES) {
				if (type === 'default') continue;
				const skipValue = urlParams.get(`${getBindName(type)}_skip`);
				if (skipValue !== null && skipValue !== '') return type;
			}
			return 'default';
		};

		// 各要素の配列を取得（アクティブなセクション内のみ）
		const getProductListElements = (type) => {
			const bindName = getBindName(type);
			const items = activeSection.querySelectorAll(`.${bindName}`);
			const productListElements = new Set();
			items.forEach(item => {
				const productListParent = item.closest('.mod-productsList01');
				if (productListParent) {
					productListElements.add(productListParent);
				}
			});
			return Array.from(productListElements);
		};

		// 0件表示テキストの要素を取得
		const getZeroResultElements = (type) => {
			return Array.from(activeSection.querySelectorAll(`.${getBindName(type)}_is_0`));
		};

		// mod-paginateを取得するヘルパー関数（アクティブなセクション内のみ）
		const getPaginationElements = (type) => {
			const bindName = getBindName(type);
			const elements = activeSection.querySelectorAll(`[class*="${bindName}_page"]`);
			const paginateElements = new Set();
			elements.forEach(el => {
				const paginateParent = el.closest('.mod-paginate');
				if (paginateParent) {
					paginateElements.add(paginateParent);
				}
			});
			return Array.from(paginateElements);
		};

		const productLists = {};
		const zeroResultTexts = {};
		const paginations = {};
		SORT_TYPES.forEach(type => {
			productLists[type] = getProductListElements(type);
			zeroResultTexts[type] = getZeroResultElements(type);
			paginations[type] = getPaginationElements(type);
		});

		// 表示切り替え関数
		const toggleDisplay = (selectedType) => {
			// 全ての商品リストとページネーションと0件表示テキストを非表示
			SORT_TYPES.forEach(type => {
				productLists[type].forEach(element => { element.style.display = 'none'; });
				zeroResultTexts[type].forEach(element => { element.style.display = 'none'; });
				paginations[type].forEach(element => { element.style.display = 'none'; });
			});

			// 選択されたタイプの要素を表示（該当が無ければdefault）
			if (!productLists[selectedType]) {
				selectedType = 'default';
			}
			productLists[selectedType].forEach(element => { element.style.display = 'flex'; });
			zeroResultTexts[selectedType].forEach(element => { element.style.display = ''; });
			paginations[selectedType].forEach(element => { element.style.display = ''; });
		};

		// 全ての並び替えskipパラメータを削除
		const removeAllSortSkipParams = (searchParams) => {
			SORT_TYPES.forEach(type => {
				searchParams.delete(`${getBindName(type)}_skip`);
			});
			return searchParams;
		};

		// 選択された並び替えの1ページ目URLを構築
		const buildFallbackUrl = (selectedType) => {
			const url = new URL(window.location.href);
			removeAllSortSkipParams(url.searchParams);
			if (selectedType !== 'default') {
				url.searchParams.set(`${getBindName(selectedType)}_skip`, '0');
			}
			return url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '');
		};

		// 並び替え変更時に1ページ目へ遷移
		const moveToSortFirstPage = (selectedType) => {
			const fallbackUrl = buildFallbackUrl(selectedType);
			if (fallbackUrl !== window.location.pathname + window.location.search) {
				window.location.href = fallbackUrl;
			}
		};

		// 初期表示（URLパラメータに基づいた並び順）
		const initialSortType = getCurrentSortType();
		sortSelect.value = initialSortType;
		toggleDisplay(initialSortType);

		// セレクトボックス変更時の処理
		sortSelect.addEventListener('change', (e) => {
			const selectedValue = e.target.value;
			toggleDisplay(selectedValue);
			moveToSortFirstPage(selectedValue);
		});
	};



	// 商品検索フォーム機能クラス
	const ProductSearchForm = class {
		constructor() {
			this.form = document.querySelector('.js-search-form');
			this.keywordInput = this.form ? this.form.querySelector('#input_01') : null;
			this.searchButton = document.querySelector('.mod-button.__submit');
			this.clearButton = document.querySelector('.js-search-clear');
			this.searchIcon = this.form ? this.form.querySelector('.mod-inputText svg') : null;

			// モバイル版フォーム要素
			this.mobileForm = document.querySelector('.search-column-right-form');
			this.mobileKeywordInput = this.mobileForm ? this.mobileForm.querySelector('#input_01') : null;
			this.mobileSearchIcon = this.mobileForm ? this.mobileForm.querySelector('.mod-inputText svg') : null;

			if (this.form || this.mobileForm) {
				this.init();
			}
		}

		init() {
			this.bindEvents();
			this.setupCollectionBrandLinking();
			this.restoreSearchConditions();
		}

		bindEvents() {
			// PC版検索フォームの送信
			if (this.form) {
				this.form.addEventListener('submit', (e) => {
					e.preventDefault();
					this.handleSearch(false);
				});
			}

			// モバイル版検索フォームの送信
			if (this.mobileForm) {
				this.mobileForm.addEventListener('submit', (e) => {
					e.preventDefault();
					this.handleSearch(true);
				});
			}

			// PC版虫眼鏡アイコンのクリック
			if (this.searchIcon) {
				this.searchIcon.addEventListener('click', () => {
					this.handleSearch(false);
				});
			}

			// モバイル版虫眼鏡アイコンのクリック
			if (this.mobileSearchIcon) {
				this.mobileSearchIcon.addEventListener('click', () => {
					this.handleSearch(true);
				});
			}

			// 条件リセット
			if (this.clearButton) {
				this.clearButton.addEventListener('click', () => {
					this.clearAllFilters();
				});
			}

			// PC版キーワード入力でEnterキー
			if (this.keywordInput) {
				this.keywordInput.addEventListener('keypress', (e) => {
					if (e.key === 'Enter') {
						e.preventDefault();
						this.handleSearch(false);
					}
				});
			}

			// モバイル版キーワード入力でEnterキー
			if (this.mobileKeywordInput) {
				this.mobileKeywordInput.addEventListener('keypress', (e) => {
					if (e.key === 'Enter') {
						e.preventDefault();
						this.handleSearch(true);
					}
				});
			}
		}

		// コレクションとブランドの連動設定
		setupCollectionBrandLinking() {
			const collectionCheckboxes = document.querySelectorAll('input[name="collection"]');
			const brandCheckboxes = document.querySelectorAll('input[name="brand"]');

			collectionCheckboxes.forEach(checkbox => {
				checkbox.addEventListener('change', (e) => {
					if (e.target.checked) {
						// コレクションが選択された時、対応するブランドを自動選択
						this.selectCorrespondingBrand(e.target);
					}
				});
			});
		}

		// 対応するブランドを選択
		selectCorrespondingBrand(collectionCheckbox) {
			const orientstarCollections = collectionCheckbox.closest('.rt_bn_orientstar_collection');
			const orientCollections = collectionCheckbox.closest('.rt_bn_orient_collection');

			if (orientstarCollections) {
				// オリエントスターのコレクションが選択された場合
				const orientstarBrand = document.querySelector('#brand_1'); // オリエントスター
				if (orientstarBrand) orientstarBrand.checked = true;
			} else if (orientCollections) {
				// オリエントのコレクションが選択された場合
				const orientBrand = document.querySelector('#brand_2'); // オリエント
				if (orientBrand) orientBrand.checked = true;
			}
		}

		// 検索処理
		handleSearch(isMobile = false) {
			const params = this.buildQueryParams(isMobile);
			const url = this.buildSearchUrl(params);

			console.log('Generated URL:', url);
			// 検索結果ページへ遷移
			window.location.href = url;
		}

		// クエリパラメータを構築
		buildQueryParams(isMobile = false) {
			const params = new URLSearchParams();

			// 商品番号検索のキーワード処理
			this.addKeywordParams(params, isMobile);

			// 条件検索のパラメータ処理
			this.addFilterParams(params);

			return params;
		}

		// PC版とモバイル版の両方からキーワードを取得
		getKeywordValue(isMobile = false) {
			// モバイル版からの検索の場合
			if (isMobile) {
				return this.mobileKeywordInput ? this.mobileKeywordInput.value.trim() : '';
			}
			// PC版からの検索の場合
			const pcKeyword = this.keywordInput ? this.keywordInput.value.trim() : '';
			const mobileKeyword = this.mobileKeywordInput ? this.mobileKeywordInput.value.trim() : '';
			// PC版が存在すればPC版、なければモバイル版
			return this.keywordInput ? pcKeyword : mobileKeyword;
		}

		// キーワードパラメータを追加
		addKeywordParams(params, isMobile = false) {
			const keyword = this.getKeywordValue(isMobile);
			console.log('keywordInput:', this.keywordInput);
			console.log('mobileKeywordInput:', this.mobileKeywordInput);
			console.log('isMobile:', isMobile);
			console.log('keyword:', keyword);

			if (keyword) {
				// スペースで分割して最大5個まで
				const keywords = keyword.split(/\s+/).slice(0, 5);
				console.log('keywords:', keywords);

				// 実際に値がある分だけパラメータを追加
				keywords.forEach((keyword, index) => {
					params.append(`p_keyword_${index + 1}`, keyword);
				});
			}
			// キーワードが空の場合はパラメータを追加しない
			console.log('Final params:', params.toString());
		}

		// フィルタパラメータを追加
		addFilterParams(params) {
			// ブランド
			this.addCheckedValues(params, 'input[name="brand"]:checked', 'p_brand');

			// コレクション
			this.addCheckedValues(params, 'input[name="collection"]:checked', 'p_collection');

			// モデル
			this.addCheckedValues(params, 'input[name="model"]:checked', 'p_models');

			// 価格帯
			this.addCheckedValues(params, 'input[name="price"]:checked', 'p_price');

			// 文字板カラー（特別な処理が必要）
			this.addDialColorParams(params);

			// 文字板素材
			this.addCheckedValues(params, '.rt_bn_tag_group_dial_material input:checked', 'p_dial_material');

			// ケースカラー
			this.addCheckedValues(params, '.rt_bn_tag_group_case_color input:checked', 'p_case_color');

			// ケース材質
			this.addCheckedValues(params, '.rt_bn_tag_group_case_material input:checked', 'p_case_material');

			// ケースサイズ
			this.addCheckedValues(params, '.rt_bn_tag_group_case_size input:checked', 'p_case_size');

			// バンド
			this.addCheckedValues(params, '.rt_bn_tag_group_strap input:checked', 'p_strap');

			// 機構
			this.addCheckedValues(params, '.rt_bn_tag_group_movement input:checked', 'p_movement');

			// 防水性能
			this.addCheckedValues(params, '.rt_bn_tag_group_water_resistant input:checked', 'p_water_resistant');

			// 駆動式
			this.addCheckedValues(params, '.rt_bn_tag_group_movement_type input:checked', 'p_movement_type');

			// 駆動時間
			this.addCheckedValues(params, '.rt_bn_tag_group_power_reserve input:checked', 'p_power_reserve');
		}

		// 文字板カラーの特別処理
		addDialColorParams(params) {
			const dialColorInputs = document.querySelectorAll('.rt_bn_tag_group_dial input:checked');
			dialColorInputs.forEach(input => {
				if (input.value) {
					params.append('p_dial', input.value);
				}
			});
		}

		// チェックされた値をパラメータに追加
		addCheckedValues(params, selector, paramName) {
			const checkedInputs = document.querySelectorAll(selector);
			checkedInputs.forEach(input => {
				if (input.value) {
					params.append(paramName, input.value);
				}
			});
		}

		// 検索URLを構築
		buildSearchUrl(params) {
			// 現在のパスから適切なベースURLを決定
			const currentPath = window.location.pathname;
			
			// 現在のURLから言語を判定
			let language = 'ja'; // デフォルト
			if (currentPath.includes('/ja/')) {
				language = 'ja';
			} else if (currentPath.includes('/en/')) {
				language = 'en';
			}
			
			let baseUrl = `/${language}/search/`;

			if (currentPath.includes(`/${language}/orient/search/`)) {
				baseUrl = `/${language}/orient/search/`;
			} else if (currentPath.includes(`/${language}/orientstar/search/`)) {
				baseUrl = `/${language}/orientstar/search/`;
			}

			const queryString = params.toString();
			return queryString ? `${baseUrl}?${queryString}` : baseUrl;
		}

		// PC版とモバイル版の両方にキーワード値を設定
		setKeywordValue(value) {
			if (this.keywordInput) {
				this.keywordInput.value = value;
			}
			if (this.mobileKeywordInput) {
				this.mobileKeywordInput.value = value;
			}
		}

		// 全フィルタをクリア
		clearAllFilters() {
			// キーワード入力をクリア（PC版とモバイル版の両方）
			this.setKeywordValue('');

			// PC版フォーム内の全てのチェックボックスをクリア
			if (this.form) {
				const allCheckboxes = this.form.querySelectorAll('input[type="checkbox"]');
				allCheckboxes.forEach(checkbox => {
					checkbox.checked = false;
				});

				// セレクトボックスをリセット
				const allSelects = this.form.querySelectorAll('select');
				allSelects.forEach(select => {
					select.selectedIndex = 0;
				});

				// アコーディオンを閉じる
				const accordions = this.form.querySelectorAll('.mod-accordion');
				accordions.forEach(accordion => {
					accordion.removeAttribute('open');
					let plus = accordion.querySelector('.mod-accordion-plus');
					plus.animate(
						{
							transform: [
								'translate(-50%, -50%) rotate(90deg)',
								'translate(-50%, -50%) rotate(0deg)'
							],
						},
						{
							duration: 300,
							pseudoElement: "::after",
							easing: 'ease',
							fill: 'forwards',
						}
					);
				});
			}
		}

		// URLパラメータから検索条件を復元
		restoreSearchConditions() {
			const params = new URLSearchParams(window.location.search);

			// キーワード検索の復元
			this.restoreKeywords(params);

			// 各フィルタ条件の復元
			this.restoreFilters(params);
		}

		// キーワード検索の復元
		restoreKeywords(params) {
			const keywords = [];

			// p_keyword_1 から p_keyword_5 まで取得
			for (let i = 1; i <= 5; i++) {
				const keyword = params.get(`p_keyword_${i}`);
				if (keyword) {
					keywords.push(keyword);
				}
			}

			if (keywords.length > 0) {
				const keywordValue = keywords.join(' ');
				this.setKeywordValue(keywordValue);
			}
		}

		// フィルタ条件の復元
		restoreFilters(params) {
			const filterMappings = [
				{ param: 'p_brand', selector: 'input[name="brand"]' },
				{ param: 'p_collection', selector: 'input[name="collection"]' },
				{ param: 'p_models', selector: 'input[name="model"]' },
				{ param: 'p_price', selector: 'input[name="price"]' },
				{ param: 'p_dial', selector: '.rt_bn_tag_group_dial input' },
				{ param: 'p_dial_material', selector: '.rt_bn_tag_group_dial_material input' },
				{ param: 'p_case_color', selector: '.rt_bn_tag_group_case_color input' },
				{ param: 'p_case_material', selector: '.rt_bn_tag_group_case_material input' },
				{ param: 'p_case_size', selector: '.rt_bn_tag_group_case_size input' },
				{ param: 'p_strap', selector: '.rt_bn_tag_group_strap input' },
				{ param: 'p_movement', selector: '.rt_bn_tag_group_movement input' },
				{ param: 'p_water_resistant', selector: '.rt_bn_tag_group_water_resistant input' },
				{ param: 'p_movement_type', selector: '.rt_bn_tag_group_movement_type input' },
				{ param: 'p_power_reserve', selector: '.rt_bn_tag_group_power_reserve input' }
			];

			filterMappings.forEach(({ param, selector }) => {
				const values = params.getAll(param);
				if (values.length > 0) {
					const inputs = document.querySelectorAll(selector);
					inputs.forEach(input => {
						if (values.includes(input.value)) {
							input.checked = true;

							// チェックされた要素の親アコーディオンを開く
							const accordion = input.closest('.mod-accordion');
							if (accordion) {
								accordion.setAttribute('open', '');
								let plus = accordion.querySelector('.mod-accordion-plus');
								plus.animate(
									{
										transform: [
											'translate(-50%, -50%) rotate(0deg)',
											'translate(-50%, -50%) rotate(90deg)'
										],
									},
									{
										duration: 300,
										pseudoElement: "::after",
										easing: 'ease',
										fill: 'forwards',
									}
								);
							}
						}
					});
				}
			});
		}
	};

	// 商品検索フォーム初期化
	const initProductSearchForm = () => {
		// 商品検索ページでのみ初期化（PC版またはモバイル版フォームが存在する場合）
		if (document.querySelector('.js-search-form') || document.querySelector('.search-column-right-form')) {
			const productSearchForm = new ProductSearchForm();
		}
	};

	// <商品詳細>
	const detailTable = () => {
		const detailTbl = document.querySelector('.js-detail-tbl');
		if (!detailTbl) return;
		const detailRows = detailTbl.querySelectorAll('tr');

		detailRows.forEach((row) => {
			const td = row.querySelector('td');
			if (!td || td.textContent.trim() === '') {
				row.remove();
			}
		});
	};

	// <商品全体>
	// 税込み価格表示（DBで管理しているのは税抜き価格のみ）
	const taxIncludedPrice = () => {
		const priceElements = document.querySelectorAll('.js-price-inc-tax');
		console.log('税抜き価格表示処理開始');
		priceElements.forEach((element) => {
			const priceContainer = element.closest('.__price');
			if (priceContainer) {
				// priceContainerを使った処理をここに追加
				const smallElement = priceContainer.querySelector('.__small>span');
				if (smallElement) {
					const priceText = smallElement.textContent;
					const priceMatch = priceText.match(/¥?([\d,]+)/);

					if (priceMatch) {
						const taxExcludedPrice = parseInt(priceMatch[1].replace(/,/g, ''));
						const taxIncludedPrice = Math.floor(taxExcludedPrice * 1.1);
						const formattedPrice = taxIncludedPrice.toLocaleString();
						element.textContent = `¥${formattedPrice}`;
						element.classList.add('is-visible');
					}
				}
			}
		});
	}

	// <商品詳細>　商品特長が空の場合、タブを非表示
	const detailFeatureTabControl = () => {
		const featureTab = document.querySelector('.js-detail-feature');
		const tabBtns = document.querySelector('.js-detail-feature-tabBtns');
		const tabContents = document.querySelector('.js-detail-feature-tabContents');

		if (!featureTab || !tabBtns) return;

		// テキストが空でも画像があれば表示する
		const hasText = featureTab.innerText.trim() !== '';
		const hasImage = featureTab.querySelector('img') !== null;
		if (!hasText && !hasImage) {
			tabBtns.style.display = 'none';
			tabContents.style.marginTop = '32px';
		}
	}

	// <商品詳細>　URLパラメータ（?tab=feature）で商品特長タブを開いた状態で表示
	const detailFeatureTabByParam = () => {
		const params = new URLSearchParams(window.location.search);
		if (params.get('tab') !== 'feature') return;

		const tabBtns = document.querySelector('.js-detail-feature-tabBtns');
		const tabContents = document.querySelector('.js-detail-feature-tabContents');
		if (!tabBtns || !tabContents) return;

		// 商品特長が空でタブが非表示の場合は切り替えない
		if (tabBtns.style.display === 'none') return;

		// 商品特長タブのボタンとコンテンツ（data-target="tabContent02"）
		const targetBtn = tabBtns.querySelector('.js-tab[data-target="tabContent02"]');
		const targetContent = tabContents.querySelector('.js-tab-content[data-target="tabContent02"]');
		if (!targetBtn || !targetContent) return;

		// 全タブ・全コンテンツを一旦非アクティブ化
		tabBtns.querySelectorAll('.js-tab').forEach((btn) => {
			btn.classList.remove(a);
		});
		tabContents.querySelectorAll('.js-tab-content').forEach((content) => {
			content.classList.remove(a);
			content.classList.remove(v);
		});

		// 商品特長タブをアクティブ化
		targetBtn.classList.add(a);
		targetContent.classList.add(a);
		targetContent.classList.add(v);
	}

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsFUNCTIONS = () => {
		searchBlock();
		detailMainSlider();
		recommendSlider();
		// displayTaxExcludedPrice();
		functionMovieControl();
		toggleSearchDisplay();
		searchResultSortControl();
		initProductSearchForm();
		detailTable();
		detailFeatureTabControl();
		detailFeatureTabByParam();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsFUNCTIONS(); }) : newsFUNCTIONS();

})(window.FUNCTIONS);
